'use client'
import Main from '@views/main'

export default function Page() {
  return <Main />
}
